<template>
  <v-autocomplete
    v-bind="$attrs"
    v-on="$listeners"
    v-model="selected"
    item-text="name"
    item-value="id"
    :loading="loading"
    :items="items"
    :menu-props="{ offsetY: true, overflowY: true, closeOnContentClick: true }"
    :label="$t('hr.document.type')"
    color="tertiary"
    clearable
  >
    <template slot="selection" slot-scope="data">
      {{ data.item.name }}
    </template>
    <template slot="item" slot-scope="data">
      {{ data.item.name }}
    </template>
  </v-autocomplete>
</template>

<script>
  import { DOCUMENT_TYPES } from "../query";

  export default {
    inheritAttrs: false,
    name: "document-type-picker",
    props: {
      value: String
    },
    data: () => ({
      loading: false,
      selected: null,
      items: []
    }),
    watch: {
      value: {
        handler(v) {
          this.selected = v;
        },
        immediate: true
      }
    },
    methods: {
      async fetchItems() {
        this.loading = true;
        await this.$apollo
          .query({
            query: DOCUMENT_TYPES
          })
          .then(({ data, errors }) => {
            if (!data.error && !errors) {
              this.items = data.documentTypes;
            }
          })
          .catch(e => {
            this.$helpers.showNotification(e.message);
          })
          .finally(() => {
            this.loading = false;
          });
      }
    },
    created() {
      this.fetchItems();
    }
  };
</script>

<style scoped></style>
